// component
import {ArrowRightIcon} from "../../components/kits/Icons/Icons";
import {SortIcon} from "../kits/Icons/Icons";
import {CloseIcon} from "../kits/Icons/Icons";
import Drawer from "../drawer/Drawer";
import {SearchNormalIcon} from "../../components/kits/Icons/Icons";
import ProductCard from "../common/ProductCard/ProductCard";
import {pathMaker} from "../../utilities/helperFunctions";
import Loader from "../kits/Loader";
import useWindowSize from "../../hooks/useWindowSize";
import CloseDrawer from "../ShopPage/CloseDrawer/CloseDrawer";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";
import CartItemBtn from "../cartitem/CartitemBtn";
import cover from "../../assets/images/defaultCover/defaultCoverProduct.png";

// style
import "./category.scss";
// react imports
import {useState, useEffect, useContext, useMemo, useRef} from "react";
import {useParams} from "react-router-dom";
import useAxios from "../../services/useAxios";
import {NavLink} from "react-router-dom";
import BoxSlider from "../common/slider/BoxSlider";
import {getBoxByPosition} from "../../utilities/apiTools";

export default function Acategory({activeBtn, setActiveBtn}) {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sortType, setSortType] = useState(-1);
    const [counter, setCounter] = useState(0);
    const [titleBtn, setTitleBtn] = useState([]);
    const [detailProduct, setDetailProduct] = useState([]);
    const [shopIsOpen, setShopISOpen] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [sublineId, setSubLineId] = useState([]);
    const [titleCategory, setTitleCategory] = useState([]);
    const [isOpenDrawerClose, setIsOpenDrawerClose] = useState(false);
    const {
        getItemCountPerShop,
        changeShoppingCartItemCount,
        shoppingListItemsFinalState,
    } = useContext(ShoppingCartItemContext);
    const shoppingCartState = shoppingListItemsFinalState;

    const {width} = useWindowSize();
    const shopId = useParams();
    const count = getItemCountPerShop(shopId.storeId);

    const productCardWidth = useMemo(() => {
        return width >= 445 ? 130 : width >= 375 ? 160 : 130;
    }, [width]);
    const ref = useRef(null);

    const handleClick = () => {
        ref.current?.scrollIntoView({behavior: "smooth"});
    };
    //api getLine
    const {execute: GetLine} = useAxios("api/getlines");

    async function GetLineFun(supplier_id, line_id) {
        await GetLine({
            // cat_id: "",
            ...(supplier_id != undefined && {supplier_id}),
            ...(line_id != undefined && {line_id}),
        }).then((res) => {
            if (res.status == 1) {
                setTitleCategory(res.lines);

                setTitleBtn(
                    res.lines[0].sublines
                        .sort(function (a, b) {
                            return a.product_count - b.product_count;
                        })
                        .reverse()
                );
                setSupplier(res.supplier);
                situationShopFunc(
                    res.supplier[0]?.start_hour,
                    res.supplier[0]?.start_min,
                    res.supplier[0]?.finish_hour,
                    res.supplier[0]?.finish_min,
                    res.supplier[0]?.main_status
                );
            }
        });
    }

    const {execute: SearchStore} = useAxios("supplier/search_products");

    async function SearchStoreFun(subline_id, search_type) {
        setLoading(true);

        await SearchStore({
            supplier_id: shopId.storeId,
            ...(search_type != undefined && {search_type}),
            line_id: shopId.lineId,
            ...(subline_id != undefined && {subline_id}),
        }).then((res) => {
            console.log(res);
            if (res.status == 1) {
                setDetailProduct(res.data);
                setLoading(false);
            } else setLoading(false);
        });
    }

    const situationShopFunc = (
        startHour,
        startMin,
        finishHour,
        finishMin,
        status
    ) => {
        let situation = <></>;
        let currentHour = new Date().getHours();
        let currentMin = new Date().getMinutes();
        if (
            currentHour < startHour ||
            currentHour > finishHour ||
            (currentHour == startHour && currentMin < startMin) ||
            (currentHour == finishHour && currentMin > finishMin) ||
            status != 0
        ) {
            setShopISOpen(false);
        } else if (
            (currentHour > startHour && currentHour < finishHour) ||
            (currentHour == startHour &&
                currentMin > startMin &&
                currentHour < finishHour) ||
            (currentHour == finishHour &&
                currentMin < finishMin &&
                currentHour > startHour)
        ) {
            setShopISOpen(true);
        }
    };

    const [boxBanners, setBoxBanners] = useState({})
    const loadBanner = async () => setBoxBanners(await getBoxByPosition("g19,g20"));

    useEffect(() => {
        loadBanner();
        SearchStoreFun();
        GetLineFun(shopId.storeId, shopId.lineId);
    }, []);
    console.log(detailProduct);

    return (
        <>
            <div
                className="parentCaregory  d-flex flex-column "
                style={{paddingBottom: Object.keys(count).length !== 0 ? 72 : 0}}
            >
                <div className="d-flex mr-t-10 pd-t-12 pd-b-12 pd-l-20  pd-r-20">
                    <div
                        style={{cursor: "pointer"}}
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        <ArrowRightIcon></ArrowRightIcon>
                    </div>
                    <div className="title">
                        {titleCategory.map((val, ind) => {
                            return (
                                <div className="mr-r-8  title-h3-b  ">{val.main.title} </div>
                            );
                        })}
                    </div>

                    <div className="icon-search d-flex justify-content-center">
                        <NavLink to={`/store-search/${shopId.storeId}`}>
                            <SearchNormalIcon width="24px" height="24px"></SearchNormalIcon>
                        </NavLink>
                    </div>
                </div>
                <div className="d-flex mr-t-6 pd-l-20  pd-r-20 box-btn pd-b-8">
                    <div>
                        <button
                            className={`desc-m btn-category    ${
                                activeBtn === -1 && "  btn-active"
                            }`}
                            // className="desc-m btn-category "
                            onClick={(e) => {
                                setActiveBtn(-1);
                                SearchStoreFun();
                            }}
                        >
                            همه
                        </button>
                    </div>
                    <>
                        {titleBtn?.map((val, ind) => {
                            return (
                                <div>
                                    {val.product_count == 0 ? (
                                        <button
                                            style={{display: "none"}}
                                            className={`desc-m btn-category btn-disable `}
                                            disabled={true}
                                        >
                                            {val.title}
                                        </button>
                                    ) : (
                                        <button
                                            // disabled={false}
                                            className={`desc-m btn-category  ${
                                                activeBtn === ind && "btn-active"
                                            }`}
                                            onClick={(e) => {
                                                setActiveBtn(ind);
                                                setSubLineId(val.suppliers_line__id);
                                                SearchStoreFun(val.suppliers_line__id);
                                            }}
                                        >
                                            {val.title}
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </>
                </div>
                <div className="line mr-t-8"></div>
                {/* sort & drawer */}
                {loading ? (
                    <div
                        className="text-center d-flex flex-column align-items-center justify-content-center flex-grow-1 "
                        style={{height: "75vh"}}
                    >
                        <div className="box-loader "></div>
                        <Loader width={40}></Loader>
                    </div>
                ) : (
                    <div className=" 100vh">
                        {detailProduct.length > 0 && (
                            <div className=" mr-t-16 pd-r-20 pd-l-20">
                                {(boxBanners.g20) && (
                                    <div className="mr-b-12">
                                        <BoxSlider banner={boxBanners.g20}/>
                                    </div>
                                )}

                                <div
                                    style={{cursor: "pointer"}}
                                    className={`d-flex box-sort  ${
                                        sortType != -1 && "active-sort "
                                    }`}
                                >

                                    <div
                                        className="mr-y-8"
                                        style={{width: "16px", height: "16px"}}
                                        onClick={(e) => {
                                            setIsOpen(true);
                                        }}
                                    >
                                        {sortType == 0 || sortType == 1 ? (
                                            <SortIcon
                                                iconClassName="active-icon"
                                                width="16px"
                                                height="16px"
                                            ></SortIcon>
                                        ) : (
                                            <SortIcon width="16px" height="16px"></SortIcon>
                                        )}
                                    </div>
                                    <div
                                        style={{cursor: "pointer"}}
                                        className={`mr-r-6 desc-m ${
                                            sortType != -1 && "active-title d-flex  desc-m"
                                        }`}
                                        onClick={(e) => {
                                            setIsOpen(true);
                                        }}
                                    >
                                        <>
                                            {sortType != -1 ? (
                                                <> مرتب سازی بر اساس: &nbsp;</>
                                            ) : (
                                                <> مرتب سازی بر اساس &nbsp;</>
                                            )}
                                            {sortType == 0 ? (
                                                <div className="d-flex">
                                                    {/* <div className="">:</div> */}
                                                    <>ارزان ترین</>
                                                    {" "}
                                                </div>
                                            ) : (
                                                sortType == 1 && <> گران ترین </>
                                            )}
                                        </>
                                    </div>
                                    <Drawer
                                        isOpen={isOpen}
                                        onClose={() => {
                                            setIsOpen(false);
                                        }}
                                        height={178}
                                    >
                                        <div className="pd-x-20 parent-drawer">
                                            <div className="demo-content">
                                                <div className="title mr-t-16 title-h4-m">
                                                    {" "}
                                                    مرتب سازی براساس{" "}
                                                </div>
                                                <div className="mr-t-16">
                                                    <div
                                                        className="d-flex item-sort  pd-t-12 pd-b-12 txt-t2-l"
                                                        style={{cursor: "pointer"}}
                                                        onClick={(e) => {
                                                            setSortType(0);
                                                            setIsOpen(false);
                                                            SearchStoreFun(sublineId, 0);
                                                        }}
                                                    >
                                                        ارزان ترین
                                                    </div>
                                                    <div
                                                        className="d-flex item-sort  pd-t-12 pd-b-12 mr-t-8 txt-t2-l"
                                                        style={{cursor: "pointer"}}
                                                        onClick={(e) => {
                                                            setSortType(1);
                                                            setIsOpen(false);
                                                            SearchStoreFun(sublineId, 1);
                                                        }}
                                                    >
                                                        گران ترین
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Drawer>
                                    <>
                                        {sortType != -1 && (
                                            <div
                                                className="mr-r-6 "
                                                onClick={(e) => {
                                                    setSortType(-1);
                                                    SearchStoreFun(sublineId);
                                                }}
                                            >
                                                {/* <div
                          className="mr-r-6 mr-l-8"
                          onClick={() => {
                            SearchStoreFun(sublineId);
                          }}
                        > */}
                                                <CloseIcon
                                                    iconClassName="active-icon"
                                                    width="16px"
                                                    height="16px"
                                                ></CloseIcon>
                                                {/* </div> */}
                                            </div>
                                        )}
                                    </>
                                </div>

                                {(boxBanners.g19) && (
                                    <div className="mr-b-12">
                                        <BoxSlider banner={boxBanners.g19}/>
                                    </div>
                                )}
                            </div>

                        )}
                        <>
                            <div className="  pd-x-20  grid-group">
                                {detailProduct?.map((val, ind) => {
                                    return (
                                        <div className="mr-t-20" style={{cursor: "pointer"}}>
                                            <ProductCard
                                                link={`/product/${shopId.storeId}/${val.id}`}
                                                title={val.product_info.title}
                                                price={val.price}
                                                cartItemCount={count[`apoId_${val.id}`]}
                                                imagePath={pathMaker(val.product_info.path)}
                                                discount={val.discount}
                                                key={`product-card-${1}`}
                                                plusOnClick={() => {
                                                    changeShoppingCartItemCount(
                                                        "add",
                                                        "",
                                                        val.total_inventory_count,
                                                        val.min_order_count,
                                                        getItemCountPerShop(shopId.storeId)[
                                                            `apoId_${val.id}`
                                                            ],
                                                        "1",
                                                        val.product_info.price,
                                                        val.id,
                                                        val.product_info.title,
                                                        shopId.storeId
                                                    );
                                                }}
                                                minusOnClick={() => {
                                                    changeShoppingCartItemCount(
                                                        "reduce",
                                                        "",
                                                        val.total_inventory_count,
                                                        val.min_order_count,
                                                        "",
                                                        "1",
                                                        val.product_info.price,
                                                        val.id,
                                                        val.product_info.title,
                                                        shopId.storeId
                                                    );
                                                }}
                                                width={productCardWidth}
                                                disabled={!shopIsOpen}
                                                disableOnClick={() => {
                                                    if (!shopIsOpen) {
                                                        setIsOpenDrawerClose(true);
                                                    }
                                                }}
                                                loading={
                                                    shoppingCartState[`state-${val.id}`] == true
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </>

                        <div>
                            <CloseDrawer
                                isOpen={isOpenDrawerClose}
                                setIsOpen={setIsOpenDrawerClose}
                                shopName={supplier[0]?.title}
                            ></CloseDrawer>
                        </div>
                    </div>
                )}
                {Object.keys(count).length !== 0 && (
                    <div className="mr-t-12">
                        <CartItemBtn isOpen2={true} height={72} shopId={shopId.storeId}/>
                    </div>
                )}
            </div>
        </>
    );
}
